import React from 'react';
import { IColumn } from '@fluentui/react';
import { Link } from 'react-router-dom';

interface IAGMDetailsData {
  agmStatus: string;
  processCount: number;
}

export function getComplianceSnapshotAGMDetailsColumns(
  companyId: number,
  agmStatuses: Array<{ id: string; fieldName: string }>,
): IColumn[] {
  const baseQueryParams = new URLSearchParams();

  baseQueryParams.append('companyIds', companyId.toString());

  const allAgmStatusNames = agmStatuses.map((status) => status.fieldName);

  const otherStatuses = allAgmStatusNames.filter(
    (status) => status !== 'Blocker' && status !== 'In Process',
  );
  // Helper function to construct filter URL for AGM Tracker
  const createAGMFilterUrl = (item: IAGMDetailsData): string => {
    const queryParams = new URLSearchParams(baseQueryParams);

    // Map AGM status to filter parameters
    if (item.agmStatus === 'Blocker') {
      queryParams.append('statuses', 'Blocker');
    } else if (item.agmStatus === 'In Process') {
      queryParams.append('statuses', 'In Process');
    } else if (item.agmStatus === 'Others') {
      // For "Others", include all statuses except Blocker and In Process
      queryParams.append('statuses', otherStatuses.join(','));
    }

    return `/agm-tracker?${queryParams.toString()}`;
  };

  return [
    {
      key: 'agmStatus',
      name: 'AGM Status',
      fieldName: 'agmStatus',
      minWidth: 250,
      maxWidth: 400,
      isResizable: true,
    },
    {
      key: 'processCount',
      name: 'Process Count',
      fieldName: 'processCount',
      minWidth: 120,
      maxWidth: 150,
      isResizable: true,
      onRender: (item: IAGMDetailsData) => {
        if (item.processCount === 0) {
          return <span style={{ color: 'inherit' }}>0</span>;
        }

        const url = createAGMFilterUrl(item);

        return <Link to={url}>{item.processCount}</Link>;
      },
    },
  ];
}

export default getComplianceSnapshotAGMDetailsColumns;
export type { IAGMDetailsData };
